import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner,
} from "@ionic/react";
import { chevronBack, trashOutline, addCircleOutline } from "ionicons/icons";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { User } from "../../../@types/user";

import addStakeholder from "../../../store/documentShow/actions/addStakeholder";

import { selectEnabledUsers } from "../../../store/documentShow/selectors/selectEnabledUsers";
import { selectSigners } from "../../../store/documentShow/selectors/selectSigners";

import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";

import { addDocumentHistory } from "../../../store/documentUpdate/actions/addDocumentHistory";
import SignersList from "./SignersList";
import { SignerSearchBar } from "./SignerSearchBar";
import { setSearchText } from "../../../store/documentShow";
import UserAvatar from "../../../components/UserAvatar";
import { RootState } from "../../../store/rootReducer";

export const DocumentSigners: React.FC = () => {
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const [disableAddStakeholder, setDisableAddStakeholder] = useState(false);

  const document = useSelector((state: RootState) => state.documentShow.document);

  const signers = useSelector(selectSigners);

  const users = useSelector(selectEnabledUsers);

  const [preselectedUsers, setPreselectedUsers] = useState<User[]>([]);

  const status = useSelector(selectDocumentStatus);

  const updateStakeholders = async () => {
    setDisableAddStakeholder(true);
    if (preselectedUsers.length > 0) {
      for (const { id, name } of preselectedUsers) {
        await dispatch(addStakeholder(id));
        await dispatch(addDocumentHistory(`agregó a ${name} como firmante`));
      }
      setDisableAddStakeholder(false);
      setPreselectedUsers([]);
      setShowModal(false);
    } else {
      return;
    }
  };
  const handlePreseselectUser = (user: User) => {
    setPreselectedUsers([...preselectedUsers, user]);
    dispatch(setSearchText(""));
  };

  const handleDeseselectUser = (user: User) => {
    preselectedUsers.includes(user) &&
      setPreselectedUsers(preselectedUsers.filter((u) => u !== user));
  };

  useEffect(() => {
    if (users.length > 0 || document) {
      setIsLoadingUsers(false);
    }
  }, [users, document]);
  return (
    <>
      <section style={{ display: "flex" }} className="ion-margin-vertical ion-padding-horizontal">
        <h5 style={{ flex: 1, margin: "auto" }}>
          {signers.length} {signers.length === 1 ? "firmante" : "firmantes"}
        </h5>
        {(status?.code === "preparing" || status?.code === "rejected") && (
          <IonButton onClick={() => setShowModal(true)} size="small" fill="solid" color="secondary">
            Agregar firmantes
            <IonIcon icon={addCircleOutline} slot="end"></IonIcon>
          </IonButton>
        )}
      </section>

      {signers?.length === 0 ? (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          Este documento no tiene firmantes aún.
        </p>
      ) : (
        <SignersList />
      )}
      {(document.signatureProvider?.name === "GuardService Inline" && signers.length > 2) && (
        <p className="ion-text-center" style={{ fontWeight: 400, color: "red" }}>* Para la firma Inline solo se permite un máximo de 2 firmantes</p>
      )}

      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowModal(false)}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>Agregar firmantes</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid>
            <IonRow>
              <IonCol size="6">
                <IonListHeader>
                  <h3>Usuarios disponibles</h3>
                </IonListHeader>
                <SignerSearchBar />
                <IonList>
                  {isLoadingUsers && <IonSpinner />}
                  {!isLoadingUsers && users.length === 0 && (
                    <p className="ion-padding">
                      <small>No se encontraron usuarios disponibles.</small>
                    </p>
                  )}
                  {!isLoadingUsers &&
                    users
                      .filter((user) => !preselectedUsers.includes(user))
                      .slice(0, 30)
                      .map((user: User) => (
                        <IonItem key={user.id}>
                          <UserAvatar user={user} />
                          <IonLabel className="ion-text-wrap">
                            <h4 style={{ fontWeight: 500 }}>{user.name}</h4>
                          </IonLabel>
                          <IonButtons slot="end">
                            <IonButton onClick={() => handlePreseselectUser(user)}>
                              <IonIcon icon={addCircleOutline} />
                            </IonButton>
                          </IonButtons>
                        </IonItem>
                      ))}
                </IonList>
              </IonCol>
              <IonCol size="6">
                <IonListHeader>
                  <h3>Seleccionados</h3>
                </IonListHeader>
                <IonList>
                  {preselectedUsers.length === 0 && (
                    <p className="ion-text-center">
                      <small>No hay usuarios seleccionados.</small>
                    </p>
                  )}
                  {preselectedUsers.map((user: User) => (
                    <IonItem key={user.id}>
                      <UserAvatar user={user} />
                      <IonLabel className="ion-text-wrap">
                        <h4 style={{ fontWeight: 500 }}>{user.name}</h4>
                      </IonLabel>
                      <IonButtons slot="end">
                        <IonButton onClick={() => handleDeseselectUser(user)}>
                          <IonIcon icon={trashOutline} />
                        </IonButton>
                      </IonButtons>
                    </IonItem>
                  ))}
                </IonList>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        <IonFooter style={{ display: "flex" }} class="ion-padding-end">
          <span style={{ display: "flex", flex: 1 }} />
          <IonButton onClick={() => updateStakeholders()} disabled={disableAddStakeholder}>
            Agregar firmantes
          </IonButton>
        </IonFooter>
      </IonModal>
    </>
  );
};
